<div class="page-container gap-24">
  <div class="page-title justify-space-between">
    <h1 class="font-bold-display-medium">Seminar Unterlagen</h1>
  </div>

  <app-file-manager
    [useCategoryColors]="false"
    [isAdminView]="true"
    [listView]="true"
    [allowRename]="true"
    [allowDelete]="true"
    [enableSeminarFilter]="true"
    [seminarFilterOptions]="seminarOptions"
    [useUploadHubFlow]="true"
    [loadAllAdminIfNoSeminarFilter]="true">
  </app-file-manager>
</div>
